export default __webpack_public_path__ + "static/media/walletConnect.1a1e5f36.png";